import { useParams } from "react-router-dom";
import React, { useContext, useEffect, useState, useRef } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import axiosInstance from "../../utils/Requests/axios";
import toast from "react-hot-toast";
import RatingSection from "./Sections/RatingSection";
import AffiliationSection from "./Sections/AffiliationSection";
import TermsSection from "./Sections/TermsSection";
import OffersSection from "./Sections/OffersSection";
import DeleteWebsiteSection from "./Sections/DeleteWebsiteSection";
import AccessDetailsSection from "./Sections/AccessDetailsSection";
import ContactsSection from "./Sections/ContactsSection";
import UserContext from "../../utils/Contexts/UserContext";
import { useNavigate } from "react-router-dom";
import BasicInfoIcon from "../svg/BasicInfo";
import AffiliationIcon from "../svg/Affiliation";
import TermsIcon from "../svg/Terms";
import OffersIcon from "../svg/Offers";
import ContactsIcon from "../svg/Contacts";
import AccessIcon from "../svg/AccessDetail";
import DeleteIcon from "../svg/Delete";
import ThemeContext from "../../utils/Contexts/ThemeContext";
import Constant from "../Constants";

import "./style.css"

function EditWeb() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);
  const { themeStatus } = Constant();
  const { userData } = useContext(UserContext);
  const { selectedTheme } = useContext(ThemeContext);
  const [domainRating, setDomainRating] = useState(null);
  const [activeNav, setActiveNav] = useState("ratingSection");
  const [hoverNav, setHoverNav] = useState(null);
  const [sectionsData, setSectionsData] = useState([]);
  const sections = [
    "ratingSection",
    "affiliationSection",
    "termsSection",
    "offersSection",
    "contactsSection",
    "accessDetailsSection",
    "deleteWebsiteSection",
  ];

  const handleNavClick = (id) => {
    setActiveNav(id);

    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: id === "ratingSection" ? 0 : section.offsetTop - 120,
        behavior: "smooth",
      });
    }
  };

  const handleHover = (section) => {
    setHoverNav(section);
  };

  const handleHoverLeave = () => {
    setHoverNav(null);
  };

  useEffect(() => {
    getDomainRatingData();
    getSectionsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const domainHistoryCalled = useRef(false);
  const getDomainRatingData = () => {
    if (domainHistoryCalled.current) return;
    domainHistoryCalled.current = true;
    const url = `/domains/${id}/history`;
    axiosInstance
      .get(url)
      .then((response) => {
        setDomainRating(response?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching domain history"));
      });
  };

  const sectionsDataCalled = useRef(false);
  const getSectionsData = () => {
    if (sectionsDataCalled.current) return;
    sectionsDataCalled.current = true;
    const url = `/domains/${id}/sellers/${userData?.uuid}/offers-summary`;
    axiosInstance
      .get(url)
      .then((response) => {
        setSectionsData(response?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching the lists data"));
      });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 992) return;
      let closestSection = null;
      let minDistance = Infinity;

      sections.forEach((sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
          const { top, bottom } = element.getBoundingClientRect();
          if (bottom > 100 && top < window.innerHeight * 0.6) {
            // Find the section closest to the viewport center
            const distance = Math.abs(top - window.innerHeight / 3);
            if (distance < minDistance) {
              minDistance = distance;
              closestSection = sectionId;
            }
          }
        }
      });

      if (closestSection) {
        setActiveNav(closestSection);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    setActiveNav("ratingSection");
    window.scrollTo(0, 0);

    let lastIsFixed = false;
    const handleScroll = () => {
      if (window.innerWidth < 992) {
        setIsFixed(false);
        return;
      }

      const shouldBeFixed = window.scrollY > 82;
      if (shouldBeFixed !== lastIsFixed) {
        setIsFixed(shouldBeFixed);
        lastIsFixed = shouldBeFixed;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <main
      id="content"
      role="main"
      className={`main ${themeStatus?.[selectedTheme]}`}
    >
      <div className="content container-fluid">
        <div
          className="page-header pb-0 mb-3"
          style={{ borderBottom: "unset" }}
        >
          <div className="row align-items-end">
            <div className="col-sm mb-2 mb-sm-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-no-gutter">
                  <li className="breadcrumb-item">
                    {/* eslint-disable-next-line */}
                    <a href="javascript:;"
                      className="breadcrumb-link breadcrumb-text opacity-50"
                      onClick={() => navigate("/websites")}
                    >
                      {t("Websites")}
                    </a>
                  </li>

                  <li
                    className="breadcrumb-item breadcrumb-text"
                    aria-current="page"
                  >
                    {t("Settings Website")}
                  </li>
                </ol>
              </nav>

              <h1 className="page-header-title">{t("Website Settings")}</h1>
            </div>
          </div>
        </div>
        <div
          className="mb-4"
          style={{
            borderBottom: `2px solid var(--border)`,
            marginLeft: "-30px",
            marginRight: "-30px",
          }}
        ></div>
        <div
          className="row d-lg-flex"
          style={{ gap: "10px", marginLeft: "auto" }}
        >
          <div className="col-lg-3 sidebar-fixed px-lg-0">
            <div className="navbar-expand-lg navbar-vertical mb-3 mb-lg-5">
              <div className="d-grid">
                <button
                  type="button"
                  className="navbar-toggler btn btn-white mb-3 rounded-1"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarVerticalNavMenu"
                  aria-label="Toggle navigation"
                  aria-expanded="false"
                  aria-controls="navbarVerticalNavMenu"
                >
                  <span className="d-flex justify-content-between align-items-center">
                    <span className="text-dark">{t("Sections")}</span>

                    <span className="navbar-toggler-default">
                      <i className="bi bi-chevron-down"></i>
                    </span>

                    <span className="navbar-toggler-toggled">
                      <i className="bi-x"></i>
                    </span>
                  </span>
                </button>
              </div>

              <div
                id="navbarVerticalNavMenu"
                className="collapse navbar-collapse rounded-3"
              >
                <ul
                  id="navbarSettings"
                  style={{
                    position: isFixed ? "fixed" : "",
                    top: isFixed && "82px",
                    border: "2px solid var(--border)",
                  }}
                  className="js-sticky-block js-scrollspy card flex-nowrap card-navbar-nav nav nav-tabs nav-lg nav-vertical sidebar-mini-fixed-website py-lg-2 d-flex flex-column justify-content-between"
                >
                  {[
                    {
                      id: "ratingSection",
                      icon: BasicInfoIcon,
                      label: t("Basic Information"),
                    },
                    {
                      id: "affiliationSection",
                      icon: AffiliationIcon,
                      label: t("Affiliation"),
                    },
                    {
                      id: "termsSection",
                      icon: TermsIcon,
                      label: t("Terms"),
                    },
                    {
                      id: "offersSection",
                      icon: OffersIcon,
                      label: t("Offer(s)"),
                    },
                    {
                      id: "contactsSection",
                      icon: ContactsIcon,
                      label: t("Contacts"),
                    },
                    {
                      id: "accessDetailsSection",
                      icon: AccessIcon,
                      label: t("Access Details"),
                    },
                    {
                      id: "deleteWebsiteSection",
                      icon: DeleteIcon,
                      label: t("Delete Website"),
                    },
                  ].map((item) => (
                    <li className="nav-item" key={item.id}>
                      <a
                        href={`#${item.id}`}
                        className={`nav-link ${
                          item.id === "deleteWebsiteSection"
                            ? "" // Always text-danger for deleteWebsiteSection
                            : activeNav === item.id
                            ? "text-primary border-primary"
                            : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavClick(item.id);
                        }}
                        onMouseEnter={() => handleHover(item.id)}
                        onMouseLeave={handleHoverLeave}
                        style={{
                          color:
                            item.id === "deleteWebsiteSection"
                              ? "#ED4C78" // Always #ED4C78 for deleteWebsiteSection
                              : activeNav === item.id || hoverNav === item.id
                              ? "#0d6efd" // Color when active or hovered
                              : selectedTheme === "dark"
                              ? "#fff"
                              : "#8c98a4",
                          borderColor:
                            item.id === "deleteWebsiteSection"
                              ? activeNav === item.id || hoverNav === item.id
                                ? "#ED4C78" // Border color for deleteWebsiteSection when active
                                : "" // No border when not active
                              : activeNav === item.id || hoverNav === item.id
                              ? "#0d6efd" // Border color when active or hovered
                              : "", // No border when not active or hovered
                          marginLeft: "-0.6rem",
                          borderLeft: "0.1675rem solid transparent",
                        }}
                      >
                        <item.icon
                          fill={
                            item.id !== "deleteWebsiteSection"
                              ? activeNav === item.id || hoverNav === item.id
                                ? "#0d6efd"
                                : selectedTheme === "dark"
                                ? "#fff"
                                : "#8c98a4"
                              : "none"
                          }
                          stroke={
                            item.id !== "deleteWebsiteSection"
                              ? activeNav === item.id || hoverNav === item.id
                                ? "#0d6efd"
                                : selectedTheme === "dark"
                                ? "#fff"
                                : "#8c98a4"
                              : "#ED4C78"
                          }
                          style={{ marginRight: "8px" }}
                        />
                        <span
                          className="text-wrap"
                          style={{ fontSize: "16px" }}
                        >
                          {item.label}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg flex-grow-1">
            <div className="d-grid gap-3 gap-lg-4">
              <RatingSection
                domainRating={domainRating}
                termsData={sectionsData}
              />
              <AffiliationSection domain={domainRating?.domain} />
              <TermsSection
                termsData={sectionsData}
                setTermsData={setSectionsData}
              />
              <OffersSection
                id={id}
                termsData={sectionsData}
                setTermsData={setSectionsData}
              />
              <ContactsSection />
              <AccessDetailsSection id={id} domain={domainRating?.domain} />
              <DeleteWebsiteSection termsData={sectionsData} />
            </div>
            <div id="stickyBlockEndPoint"></div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default EditWeb;
